import { FC, memo, PropsWithChildren } from 'react';

import { dom } from 'app/utils';
import { Tooltip as Component, TooltipProps as Props } from '../external';
import { ITooltipOptions } from '../types';
import * as React from 'react';

export interface ITooltip extends PropsWithChildren<ITooltipOptions> {
  target: string | string[] | HTMLElement | React.RefObject<HTMLElement> | undefined;
}

export const Tooltip: FC<ITooltip> = memo(({ id, className, style, disabled, label, position, target, children }) => {
  const props: Props = { id, style, disabled, position, target, children,
    className: dom.className('i-component', 'i-tooltip', className),
    content: label,
  };

  return <Component { ...props } />;
});
